import React, { useEffect, useState, useRef } from "react";
import "./BulkUploadInfoModal.css";

const BulkUploadInfoModal = ({ showModal, onClose, onAlpha2Click, onUpload }) => {
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState("");
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (showModal) setVisible(true);
  }, [showModal]);

  const handleCloseWithTransition = (callback) => {
    setVisible(false);
    setTimeout(() => {
      callback && callback();
    }, 300);
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-excel", // .xls
    ];

    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (
      !allowedTypes.includes(file.type) &&
      fileExtension !== "xlsx" &&
      fileExtension !== "xls"
    ) {
      setError("Only Excel files (.xlsx, .xls) are allowed.");
      e.target.value = null;
      return;
    }

    setError("");
    console.log("Valid Excel file selected:", file);

    if (onUpload) {
      onUpload(file);
    }
    e.target.value = null;
  };


  if (!showModal && !visible) return null;

  return (
    <div className="bu-modal-overlay">
      <div className={`bu-modal ${visible ? "open" : "close"}`}>
        <div className="bu-header">
          <h2>Bulk Upload</h2>
        </div>

        <div className="bu-body">
          <p className="bu-intro">Please follow these rules:</p>

          <ul className="bu-rules">
            <li>
              Use the Service ID from the Manage Service Module and paste in the Excelsheet.
            </li>
            <li>
              Add multiple service ID's by separating commas (,).
            </li>
            <li className="bu-inline-cta">
              If you need Alpha 2 country codes, click here:
              <button
                className="bu-chip"
                onClick={() => handleCloseWithTransition(onAlpha2Click)}
                aria-label="Open Alpha 2 code reference"
              >
                Alpha 2 Code
              </button>
            </li>
          </ul>

          {error && <p className="bu-error">{error}</p>}
        </div>

        <div className="bu-footer">
          <button
            className="bu-btn bu-btn-secondary"
            onClick={() => handleCloseWithTransition(onClose)}
          >
            Close
          </button>

          <button className="bu-btn bu-btn-primary" onClick={handleUploadClick}>
            Upload Excel
          </button>

          <input
            type="file"
            ref={fileInputRef}
            className="bu-file-input"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
          />
        </div>
      </div>
    </div>
  );
};

export default BulkUploadInfoModal;
